module.exports = __webpack_public_path__ + "img/115.63e01660.png";